{
  "title": "Rejista ya SOR",
  "subtitle": "Usimamizi wa Mikopo ya Kaboni",
  "memberSubtitle": "Dashibodi ya Mtengenezaji wa Mradi",
  "welcome": "Karibu",
  "login": "Ingia",
  "logout": "Toka"
}